import { render, staticRenderFns } from "./mymeeting.vue?vue&type=template&id=2cf490b3&scoped=true"
import script from "./mymeeting.vue?vue&type=script&lang=js"
export * from "./mymeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf490b3",
  null
  
)

export default component.exports